// Public configuration only. Service-role keys and provider tokens never enter this module.
export function browserSupabaseUrl(env) {
  const stage = env.REACT_APP_RELEASE_ENVIRONMENT === 'staging' || Boolean(env.REACT_APP_STAGING_SUPABASE_REF);
  if (!stage) return 'https://slyzdfygyjxnsfdgdxuh.supabase.co'; // existing production behavior
  const ref = env.REACT_APP_STAGING_SUPABASE_REF;
  const url = env.REACT_APP_SUPABASE_URL;
  const key = env.REACT_APP_SUPABASE_ANON_KEY;
  if (env.REACT_APP_RELEASE_ENVIRONMENT !== 'staging' || !/^[a-z]{20}$/.test(ref || '') || ref === 'slyzdfygyjxnsfdgdxuh' || url !== `https://${ref}.supabase.co` || !key) throw Error('Staging authentication unavailable');
  if (key.startsWith('sb_')) {
    if (!key.startsWith('sb_publishable_')) throw Error('Staging authentication unavailable');
  } else {
    let claims;
    try { claims = JSON.parse(atob(key.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))); } catch { throw Error('Staging authentication unavailable'); }
    if (claims.ref !== ref || claims.role !== 'anon') throw Error('Staging authentication unavailable');
  }
  return url;
}
